














import {
  defineComponent, computed, ref, onMounted,
} from '@vue/composition-api';

export default defineComponent({
  name: 'ClientOnlyPrice',
  props: {
    tag: { type: String, default: 'span' },
    wrapperClass: { type: [String, Array, Object], default: '' },
    placeholderClass: { type: [String, Array, Object], default: '' },
    placeholder: { type: String, default: '$—' },
    // generic reserve controls (optional)
    reserveCh: { type: Number, default: 0 },
  },
  setup(props) {
    const isMounted = ref(false);

    onMounted(() => {
      isMounted.value = true;
    });

    const placeholderStyle = computed(() => (props.reserveCh ? { display: 'inline-block', minWidth: `${props.reserveCh}ch` } : {}));

    return {
      isMounted,
      placeholderStyle,
    };
  },

});
